// import moment from "moment/moment";


class Utils {

    /**
     * 
     * @param {string} selector 
     * @returns {HTMLElement | null}
     */
    static querySelector(selector) {
        return document.querySelector(selector);
    }

    /**
     * 
     * @param {string} html 
     * @returns {HTMLElement | Element | null}
     */
    static HtmlToDom(html) {
        const d = document.createElement('div');
        d.innerHTML = html;
        return d.children[0];
    }

    static QueryUrlParameter(key) {
        return decodeURIComponent((new URL(document.location.toString())).searchParams.get(key) || '').trim();
    }

    static GetParentLocation() {
        return document.referrer;
    }

    static GetDefaultOrigin() {
        return window.location.origin;
    }

    static GenerateUniqueID() {
        function _p8(s) {
            var p = (Math.random().toString(16) + "000000000").substring(2, 8);
            return s ? "-" + p.substring(0, 4) + "-" + p.substring(4, 4) : p;
        }
        return _p8() + _p8(true) + _p8(true) + _p8();
    }

    static Delay(millisecond) {
        return new Promise(next => setTimeout(next, millisecond));
    }

    static IsIFrame() {
        return window.top !== window.self;
    }

    static IsFunction(obj) {
        return typeof obj === 'function';
    }

    /**
     * 
     * @param {string} formUUID 
     * @returns {HTMLIFrameElement | null}
     */
    static QueryFormIFrame(formUUID) {
        return document.querySelector(`iframe#tai-${formUUID}`);
    }

    /**
     * 
     * @param {string} value 
     */
    static WordCounter(value) {
        // return value.trim().split(' ').length;
        if(value.length == 0){
            return 0;
        }
        return value.trim().replace(/\s\s+/g, ' ').split(' ').length;
    }

}

export default Utils;